import type { MetaTagsProps } from './MetaTags';

export { default } from './MetaTags';
export type { MetaTagsProps };
